import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import appSettingsServices from '@src/services/appSettings.services';

export const getAppSettings = createAsyncThunk(
  'getAppSettings',
  async ({ code }, { getState, dispatch, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      return await appSettingsServices.getAppSettings({ code: code, customerId: customerId });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getCustomerSmpl = createAsyncThunk(
  'getCustomerSmpl',
  async (body, { getState, dispatch, rejectWithValue }) => {
    try {
      const customerId = getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      return await appSettingsServices.getCustomerSmpl(customerId);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  appSettings: {},
  customerSmpl: {},
  loadingState: true,
  requestCount: 0,
  fullWidth: false,
  spinText: '',
  showLoader: false,
};

export const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    setLoadingState: (state, action) => {
      state.loadingState = action.payload;
    },
    setFullWidth: (state, action) => {
      state.fullWidth = action.payload;
    },
    incrementRequestCount: (state, action) => {
      state.requestCount += 1
    },
    decrementRequestCount: (state, action) => {
      state.requestCount -= 1
    },
    setRequestCount: (state, action) => {
      state.requestCount = action.payload;
    },
    setSpinText: (state, action) => {
      state.spinText = action.payload;
    },
    setShowLoader: (state, action) => {
      state.showLoader = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAppSettings.fulfilled, (state, action) => {
      state.appSettings[action?.meta?.arg?.code] = action.payload.data
    });
    builder.addCase(getCustomerSmpl.fulfilled, (state, action) => {
      state.customerSmpl = action.payload?.data;
    });
  },
});

export const {
  setSpinText,
  setRequestCount,
  decrementRequestCount,
  incrementRequestCount,
  setFullWidth, appSettings,
  customerSmpl,
  setLoadingState,
  setShowLoader
} = appSettingsSlice.actions;
